<template>
  <div class="o-transition-type-selector">
    <m-form-input id="o-transition-type-selector__form-input" class="o-transition-type-selector__form-input">
      <a-text id="o-transition-type-selector__a-text" class="o-transition-type-selector__a-text"
        >タップ時の遷移先</a-text
      >
      <a-radio
        id="o-transition-type-selector__radio__url"
        v-model="transitionTypeChild"
        class="o-transition-type-selector__radio o-transition-type-selector__radio__url"
        :disabled="disabled"
        name="transitionType"
        value="url"
        label="外部Webサイト"
        data-testid="add-banner-transitionType-url"
      />
      <a-radio
        id="o-transition-type-selector__radio__campaign"
        v-model="transitionTypeChild"
        class="o-transition-type-selector__radio o-transition-type-selector__radio__campaign"
        :disabled="disabled"
        name="transitionType"
        value="campaign"
        label="アプリ内記事セミナー"
        data-testid="add-banner-transitionType-campaign"
      />
      <a-radio
        id="o-transition-type-selector__radio__info"
        v-model="transitionTypeChild"
        class="o-transition-type-selector__radio o-transition-type-selector__radio__info"
        :disabled="disabled"
        name="transitionType"
        value="info"
        label="アプリ内お知らせ"
        data-testid="add-banner-transitionType-info"
      />
    </m-form-input>
    <m-form-input v-if="transitionTypeChild === 'url'">
      <a-apply-text-field
        id="o-transition-type-selector__contents-url"
        v-model="contentsUrlChild"
        class="o-transition-type-selector__contents-url"
        :disabled="disabled"
        data-testid="add-banner-url-input"
        type="text"
        maxlength="500"
        maxlength-id="add-banner-url-maxlength"
        placeholder="URL"
      />
    </m-form-input>
    <m-form-input v-if="transitionTypeChild === 'campaign'">
      <a-select-field
        v-if="updatedCampaignFlag"
        id="o-transition-type-selector__transition-doc-campaign"
        v-model="transitionCampaignDocChild"
        class="o-transition-type-selector__transition-doc-campaign"
        :disabled="disabled"
        :options="transitionDocCampaignOptions"
      />
    </m-form-input>
    <m-form-input v-if="transitionTypeChild === 'info'">
      <a-select-field
        v-if="updatedInfoFlag"
        id="o-transition-type-selector__transition-doc-info"
        v-model="transitionInfoDocChild"
        class="o-transition-type-selector__transition-doc-info"
        :disabled="disabled"
        :options="transitionDocInfoOptions"
      />
    </m-form-input>
  </div>
</template>

<script>
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import AApplyTextField from '@/components/atoms/apply-text-field';
import ARadio from '@/components/atoms/radio';
import { utils } from '@/common/utils.js';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 'o-transition-type-selector',
  components: {
    MFormInput,
    ASelectField,
    AApplyTextField,
    ARadio,
  },
  mixins: [customRequest],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    transitionType: {
      type: String,
      default: 'web',
    },
    transitionDoc: {
      type: String,
      default: '',
    },
    contentsUrl: {
      type: String,
      default: '',
    },
  },
  emits: ['update:transitionType', 'update:transitionDoc', 'update:contentsUrl'],
  data() {
    return {
      transitionTypeChild: '',
      transitionCampaignDocChild: '',
      transitionInfoDocChild: '',
      contentsUrlChild: '',
      transitionDocInfoOptions: [],
      updatedInfoFlag: false,
      transitionDocCampaignOptions: [],
      updatedCampaignFlag: false,
    };
  },
  watch: {
    transitionTypeChild(val) {
      this.$emit('update:transitionType', val);
      if (val === 'campaign') {
        this.$emit('update:transitionDoc', this.transitionCampaignDocChild);
      } else if (val === 'info') {
        this.$emit('update:transitionDoc', this.transitionInfoDocChild);
      }
    },
    transitionCampaignDocChild(val) {
      this.$emit('update:transitionDoc', val);
    },
    transitionInfoDocChild(val) {
      this.$emit('update:transitionDoc', val);
    },
    contentsUrlChild(val) {
      this.$emit('update:contentsUrl', val);
    },
  },
  async mounted() {
    this.transitionTypeChild = this.transitionType;
    if (this.transitionType === 'campaign') {
      this.transitionCampaignDocChild = this.transitionDoc;
    } else if (this.transitionType === 'info') {
      this.transitionInfoDocChild = this.transitionDoc;
    }
    this.contentsUrlChild = this.contentsUrl;
    await this.getInfoData();
    await this.getCampaignData();
  },
  methods: {
    // info(NEWS / announcement)のデータを取得
    async getInfoData() {
      const res = await this.postRequest('/announcements/get-list', { execUserID: this.execUserID });
      if (res.status === 'success') {
        this.transitionDocInfoOptions = this.transformToOptionData(res.data);
        if (this.transitionDoc && !this.transitionDocInfoOptions.some(item => item.value === this.transitionDoc)) {
          const id = this.transitionDoc;
          const doc = await this.postRequest('/announcements/get', { id });
          if (doc.status === 'success') {
            this.transitionDocInfoOptions = [this.getCurrentSelectedItem(id, doc), ...this.transitionDocInfoOptions];
          } else {
            if (res.message) {
              this.showErrorModal(res.message);
            } else {
              this.showErrorModal(messageContent.requireTry('お知らせデータ取得'));
            }
          }
        }
        this.updatedInfoFlag = true;
      } else {
        if (res.message) {
          this.showErrorModal(res.message);
        } else {
          this.showErrorModal(messageContent.requireTry('お知らせデータ取得'));
        }
      }
    },
    // campaign(アプリ関連)のデータを取得
    async getCampaignData() {
      const res = await this.postRequest('/campaigns/get-list', { execUserID: this.execUserID });
      if (res.status === 'success') {
        this.transitionDocCampaignOptions = this.transformToOptionData(res.data);
        if (this.transitionDoc && !this.transitionDocCampaignOptions.some(item => item.value === this.transitionDoc)) {
          const id = this.transitionDoc;
          const doc = await this.postRequest('/campaigns/get', { id });
          if (doc.status === 'success') {
            this.transitionDocCampaignOptions = [
              this.getCurrentSelectedItem(id, doc),
              ...this.transitionDocCampaignOptions,
            ];
          } else {
            if (res.message) {
              this.showErrorModal(res.message);
            } else {
              this.showErrorModal(messageContent.requireTry('記事・セミナー（一覧）データ取得'));
            }
          }
        }
        this.updatedCampaignFlag = true;
      } else {
        if (res.message) {
          this.showErrorModal(res.message);
        } else {
          this.showErrorModal(messageContent.requireTry('記事・セミナー（一覧）データ取得'));
        }
      }
    },
    // 現在の選択されたアイテムを取得
    getCurrentSelectedItem(id, doc) {
      if (doc.data && doc.data.data) {
        const data = doc.data.data;
        const publishStatusLabel = utils.getPublishStatusLabel(data);
        return {
          value: id,
          label: `[現在選択][${publishStatusLabel}] ${id} ${data.title}`,
          data: data,
        };
      } else {
        return {
          value: id,
          label: `[現在選択][削除] ${id}`,
          data: null,
        };
      }
    },
    // info/campaignのデータをselect-field用optionDataに変換
    transformToOptionData(dataArray) {
      const ret = [];
      for (const id in dataArray) {
        const publishStatus = utils.getPublishStatus(dataArray[id]);
        if (publishStatus === 'ended' || publishStatus === 'unapproved') {
          continue;
        }
        const publishStatusLabel = publishStatus === 'published' ? '公開中' : '未公開';
        ret.push({
          value: id,
          label: `[${publishStatusLabel}] ${id} ${dataArray[id].title}`,
          data: dataArray[id],
        });
      }
      ret.sort((a, b) => (a.data.castStartDate > b.data.castStartDate ? 1 : -1));
      return ret;
    },
  },
};
</script>
